import { render, staticRenderFns } from "./formDocument.vue?vue&type=template&id=25cbae55&lang=pug&"
import script from "./formDocument.vue?vue&type=script&lang=js&"
export * from "./formDocument.vue?vue&type=script&lang=js&"
import style0 from "./formDocument.vue?vue&type=style&index=0&id=25cbae55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports